<template>
  <div>
    <div class="chart-box-top">
      <span class="chart-title">公司事件原因类趋势图</span>
      <div class="chart-select-container">
        <div class="el-select-wrapper">
          <el-select v-model="eventReason" placeholder="请选择">
            <el-option v-for="item in eventReasonOptions" :key="item.code" :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div ref="chart" class="chart-main">
    </div>
    <el-dialog title="明细列表" :visible.sync="detailVisible" width="95%">
      <SymptomDetail ref="detail" :symptom="eventReason" :company="company" :year="year"
                     :month="barMonth"></SymptomDetail>
    </el-dialog>
  </div>
</template>

<script>
import SymptomDetail from "./SymptomDetail";
import {getRequest} from "../../../utils/request";
import {showMessage} from "../../../utils/notice";

export default {
  props: {
    year: Number,
    company: String,
    eventReasonOptions: Array,
  },
  data() {
    return {
      eventReason: "SR-200",
      xAxisData: [],
      eventCounts: [],
      thousandCountRates: [],
      //右Y轴单位
      actualValueMeasuringUnit: "千次率",
      //是否显示明细列表
      detailVisible: false,
      //用户点击的月份
      barMonth: null,
      chart: null,
    }
  },
  mounted() {
    let queryEventReason = this.$route.query.eventReason;
    if (this.eventReasonOptions.some(option => option.code === queryEventReason))
      this.eventReason = queryEventReason;

    this.buildChart();
    window.addEventListener('resize', () => {
      this.chart && this.chart.resize()
    })
  },
  methods: {
    buildChart() {
      let kpi = this.eventReasonOptions.find(option => option.code === this.eventReason);
      this.actualValueMeasuringUnit = kpi.measuringUnitName;

      getRequest("/result/symptom/chart/trend", {
        symptom: this.eventReason,
        company: this.company,
        year: this.year
      }, this.$refs.chart).then(res => {
        //1.重新构建图表数据
        this.xAxisData = [];
        this.eventCounts = [];
        this.thousandCountRates = [];

        res.data.forEach(item => {
          this.xAxisData.push(item.month + "月");
          this.eventCounts.push({value: item.eventCount, full: item});

          if (kpi.measuringUnit === "1000timesRte") {
            this.thousandCountRates.push({value: item.thousandCountRate, full: item});
          } else if (kpi.measuringUnit === "10000hourRate") {
            this.thousandCountRates.push({value: item.tenThousandHourRate, full: item});
          } else if (kpi.measuringUnit === "10000timesRate") {
            this.thousandCountRates.push({value: item.tenThousandCountRate, full: item});
          } else {
            let errorMessage = "该指标选择的单位不支持，请在KPI总库中修改";
            showMessage(errorMessage, "error")
            throw new Error(errorMessage)
          }

        })
        this.chart = this.$echarts.init(this.$refs.chart);
        this.chart.setOption(this.getOption());
        this.chart.on("click", "series.bar", params => {
          this.barMonth = params.data.full.month;
          this.detailVisible = true;
          this.$refs.detail && this.$refs.detail.initPage();
        })

        this.$util.adjustYaxis(this.chart, this.$util.getMax(this.thousandCountRates));
      });
    },
    getOption() {
      return {
        grid: {
          containLabel: true,
          left: 0,
          right: 0,
          bottom: 0
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
          padding: [5, 10],
          confine: true
        },
        legend: {
          itemWidth: 12,
          itemHeight: 12,
        },
        xAxis: {
          data: this.xAxisData,
          axisLabel: {
            fontSize: 11,
            color: "#bebebe",
            interval: 0
          },
          axisTick: {
            show: false
          }
        },
        yAxis: [
          {
            name: "起",
            nameTextStyle: {
              color: "#bebebe",
              fontSize: 11,
              //"起"字与左y轴对齐
              align: "right",
              padding: [0, 5, 0, 0]
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            axisLabel: {
              color: "#bebebe"
            }
          }, {
            name: this.actualValueMeasuringUnit,
            nameTextStyle: {
              color: "#bebebe",
              fontSize: 11,
              //"千次率"与右y轴对齐
              align: "center",
              padding: [0, 0, 0, 20]
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            axisLabel: {
              color: "#bebebe"
            }
          }],
        series: [
          {
            name: '事件数量',
            type: 'bar',
            data: this.eventCounts,
            yAxisIndex: 0,
            barWidth: 10,
            itemStyle: {
              color: "#257dff"
            },
          }, {
            name: this.actualValueMeasuringUnit,
            type: 'line',
            data: this.thousandCountRates,
            yAxisIndex: 1,
            //默认是空心圆，改为实心圆，大小为6
            symbol: "circle",
            symbolSize: 6,
            itemStyle: {
              color: "#F3A800",
              borderType: "solid"
            },
            lineStyle: {
              color: "#F3A800",
            },
          }]
      };
    },
  },
  watch: {
    year() {
      this.buildChart();
    },
    company() {
      this.buildChart();
    },
    eventReason() {
      this.buildChart();
    }
  },
  components: {SymptomDetail}
}
</script>

<style scoped lang="less">
.el-select-wrapper:nth-child(1) {
  width: 115px;
}
</style>



// WEBPACK FOOTER //
// src/components/achievement/result/EventReasonTrend.vue